import React, { useContext } from 'react'
import { Formik } from 'formik'
import { Button, Form, Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'
import FormView from 'src/components/Form/View'

const JoinRegistrationForm = ({
   currentStepNumber,
   initialRegistrationFormValues,
   onGoBack,
   onContinue,
   numTotalSteps
}) => {
   const { initiative } = useContext(InitiativeHierarchyContext)

   /* eslint-disable camelcase */
   const elements = initiative?.apps?.registration_form?.elements || []
   /* eslint-enable camelcase */

   return (
      <Formik
         initialValues={initialRegistrationFormValues}
         onSubmit={onContinue}
         render={({ handleSubmit, isSubmitting, values }) => (
            <Form
               elementAppearance="plain"
               elementBackgroundColor="#eee"
               elementFocusBackgroundColor="#f3f3f3"
               onSubmit={handleSubmit}>
               <View
                  position="absolute"
                  top="0px"
                  left="0px"
                  width="100%"
                  height="100%"
                  scroll="on[a-b]">
                  <View
                     width="100%"
                     height="calc(100% - 72px)[c-f]"
                     scroll="on[c-f]">
                     <View
                        display="flex"
                        alignItems="center"
                        width="100%"
                        minHeight="90px"
                        padding="24px 18px[a] 24px 30px[b-f]"
                        borderBottom="1px solid #eee">
                        <View>
                           <Text size="4" weight="medium">
                              {initiative.name}
                           </Text>
                           <Text size="2" color="#888">
                              {`Step ${currentStepNumber} of ${numTotalSteps} `}
                              &mdash;
                              Fill in the following:
                           </Text>
                        </View>
                     </View>
                     <View
                        width="100%"
                        padding="18px 18px 0px 18px[a] 18px 30px 0px 30px[b-f]">
                        <FormView elements={elements} />
                     </View>
                  </View>
                  <View
                     display="flex"
                     justifyContent="flex-end"
                     alignItems="center"
                     position="relative[a-b] absolute[c-f]"
                     bottom="0px[c-f]"
                     left="0px[c-f]"
                     width="100%"
                     height="72px"
                     padding="0px 18px[a] 0px 24px[b-f]"
                     borderTop="1px solid #eee">
                     <View>
                        <Button
                           onClick={() => onGoBack(values)}
                           color="#eee"
                           textColor="#444"
                           size="md"
                           mode={isSubmitting ? 'disabled' : 'normal'}
                           name="Previous"
                        />
                        <Button
                           type="submit"
                           size="md"
                           color="#35b865"
                           mode={isSubmitting ? 'loading' : 'normal'}
                           name={currentStepNumber === numTotalSteps
                              ? 'Register'
                              : 'Continue'
                           }
                        />
                     </View>
                  </View>
               </View>
            </Form>
         )}
      />
   )
}

JoinRegistrationForm.propTypes = {
   currentStepNumber: PropTypes.number.isRequired,
   initialRegistrationFormValues: PropTypes.object,
   onGoBack: PropTypes.func.isRequired,
   onContinue: PropTypes.func.isRequired,
   numTotalSteps: PropTypes.number.isRequired
}

JoinRegistrationForm.defaultProps = {
   initialRegistrationFormValues: {}
}

export default JoinRegistrationForm
